//// Application Configuration
import { store } from '../store'

//// Application Packages

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

// Get Current Settings Data From Store
export const extractSettingsDataSession = () => {
    const settings = store?.getState()?.['settings']
    if (settings) {
        return settings
    } else {
        return null
    }
}

// Get Current Authorizations Data From Store
export const extractAuthorizationsDataSession = () => {
    const authorizations = store?.getState()?.['authorizations']
    if (authorizations) {
        return authorizations
    } else {
        return null
    }
}

// Get Current Account Data From Store
export const extractAccountDataSession = () => {
    const account = store?.getState()?.['account']
    if (account) {
        return account
    } else {
        return null
    }
}

// Get Current Forms Data From Store
export const extractFormsDataSession = () => {
    const forms = store?.getState()?.['forms']
    if (forms) {
        return forms
    } else {
        return null
    }
}

// Get Current Cache Data From Store
export const extractCacheDataSession = () => {
    const cache = store?.getState()?.['cache']
    if (cache) {
        return cache
    } else {
        return null
    }
}
